import {Component, EventEmitter, Input, OnInit, Output, DoCheck} from '@angular/core';
import {JanelaPermissaoOcorrencia} from './../../model/catalogo';
import {DiaSemana, DiaMes, Anos, JanelaCodTipoDiaUtil} from './../../model/constantes';
import {ToadMensagemService} from './../../service/toad-mensagem.service';

@Component({
    selector: 'app-cadastro-janela-permissao-ocorrencia',
    templateUrl: './cadastro-janela-permissao-ocorrencia.component.html',
    styleUrls: ['./cadastro-janela-permissao-ocorrencia.component.css']
})
export class CadastroJanelaPermissaoOcorrenciaComponent implements OnInit, DoCheck {

    listaJanelaPermissaoOcorrencias: Array<JanelaPermissaoOcorrencia> = new Array<JanelaPermissaoOcorrencia>();

    janelaPermissaoOcorrencia: JanelaPermissaoOcorrencia = new JanelaPermissaoOcorrencia();

    diaSemanas: DiaSemana[];

    diasMes: DiaMes[];

    selected: DiaSemana;

    selectedDia: DiaMes;

    selectedAno: Anos;

    anos: Anos[];

    chaveComposta: any;

    selectedCodTipoDiaUtil: JanelaCodTipoDiaUtil = new JanelaCodTipoDiaUtil();

    listaCodTipoDiaUtil = [];

    @Output() janelaPermissaoAdicionada = new EventEmitter();

    @Input() newJanelaPermissaoOcorrencia: any;

    constructor(private messageService: ToadMensagemService) {
        // this.formataCalendario = FormataCalendario.getCalendario();
        this.diaSemanas = [
            {codigo: 0, descricao: 'Todos'},
            {codigo: 1, descricao: 'Domingo'},
            {codigo: 2, descricao: 'Segunda'},
            {codigo: 3, descricao: 'Quarta'},
            {codigo: 4, descricao: 'Quinta'},
            {codigo: 5, descricao: 'Sexta'},
            {codigo: 6, descricao: 'Sábado'},
        ];

        this.diasMes = [
            {codigo: 0, descricao: 'Todos'},
            {codigo: 1, descricao: '1'},
            {codigo: 2, descricao: '2'},
            {codigo: 3, descricao: '3'},
            {codigo: 4, descricao: '4'},
            {codigo: 5, descricao: '5'},
            {codigo: 6, descricao: '6'},
            {codigo: 1, descricao: '7'},
            {codigo: 2, descricao: '8'},
            {codigo: 3, descricao: '9'},
            {codigo: 4, descricao: '10'},
            {codigo: 5, descricao: '11'},
            {codigo: 6, descricao: '12'},
            {codigo: 1, descricao: '13'},
            {codigo: 2, descricao: '14'},
            {codigo: 3, descricao: '15'},
            {codigo: 4, descricao: '16'},
            {codigo: 5, descricao: '17'},
            {codigo: 6, descricao: '18'},
            {codigo: 1, descricao: '19'},
            {codigo: 2, descricao: '20'},
            {codigo: 3, descricao: '21'},
            {codigo: 4, descricao: '22'},
            {codigo: 5, descricao: '23'},
            {codigo: 6, descricao: '24'},
            {codigo: 6, descricao: '25'},
            {codigo: 6, descricao: '26'},
            {codigo: 6, descricao: '27'},
            {codigo: 6, descricao: '28'},
            {codigo: 6, descricao: '29'},
            {codigo: 6, descricao: '30'},
            {codigo: 6, descricao: '31'},
        ];

        let year = new Date().getFullYear();
        this.anos = [];
        this.anos.push({codigo: year, descricao: year + ''});
        for (var i = 1; i < 13; i++) {
            let ano = year + 1;
            year++;
            this.anos.push({codigo: ano, descricao: ano + ''});
        }

    }

    ngOnInit() {

        this.listaCodTipoDiaUtil = [
            {codigo: 1, descricao: 'Dia Útil/Dia Mês Não Ordinal'},
            {codigo: 2, descricao: 'Dia Não Útil/Dia Mês Não Ordinal'},
            {codigo: 3, descricao: 'Dia Útil E Não Útil/Dia Mês Não Ordinal'},
            {codigo: 4, descricao: 'Dia Útil/Dia Mês Ordinal'},
            {codigo: 5, descricao: 'Dia Não Útil/Dia Mês Ordinal'},
            {codigo: 6, descricao: 'Dia Útil E Não Útil/Dia Mês Ordinal'},
        ];
    }

    // Um método de retorno uma chamada que executa a detecção de alterações
    ngDoCheck(): void {

        if (this.newJanelaPermissaoOcorrencia != undefined) {
            this.listaJanelaPermissaoOcorrencias = new Array<JanelaPermissaoOcorrencia>();
            this.listaJanelaPermissaoOcorrencias = this.newJanelaPermissaoOcorrencia;
            this.janelaPermissaoAdicionada.emit(this.listaJanelaPermissaoOcorrencias);
        }
    }

    adicionarJanelaPermissao() {

        // if (this.janelaPermissaoOcorrencia.diaMes < 1 || this.janelaPermissaoOcorrencia.diaMes > 31) {
        //   this.messageService.addErrorKey('Dia do Mês inválido.', this.chaveComposta);
        //   return { 'invalid': true };
        // }

        this.janelaPermissaoOcorrencia.diaSemana = this.selected.codigo;

        this.janelaPermissaoOcorrencia.diaMes = this.selectedDia.codigo;

        this.janelaPermissaoOcorrencia.ano = this.selectedAno.codigo;

        this.janelaPermissaoOcorrencia.codTipoDiaUtil = this.selectedCodTipoDiaUtil.codigo;

        if (this.janelaPermissaoOcorrencia.ano == 0) {

            let dataAtual = new Date();

            this.janelaPermissaoOcorrencia.ano = dataAtual.getFullYear();
        }

        this.listaJanelaPermissaoOcorrencias.push(this.janelaPermissaoOcorrencia);

        this.janelaPermissaoOcorrencia = new JanelaPermissaoOcorrencia();

        this.janelaPermissaoAdicionada.emit(this.listaJanelaPermissaoOcorrencias);
    }

    // método que editar Janela Permissão Ocorrência
    onRowSelectJanelaPermissaoOcorrencia(item) {

        this.janelaPermissaoOcorrencia.diaSemana = item.diaSemana;
        this.janelaPermissaoOcorrencia.diaMes = item.diaMes;
        this.janelaPermissaoOcorrencia.ano = item.ano;
        this.janelaPermissaoOcorrencia.codTipoDiaUtil = item.codTipoDiaUtil;
        this.janelaPermissaoOcorrencia.horaInicio = item.horaInicio;
        this.janelaPermissaoOcorrencia.horaFim = item.horaFim;

        this.removerJanelaPermissaoOcorrencia(item);

    }

    // excluir o indice selecionado
    removerJanelaPermissaoOcorrencia(indice: any) {

        const index = this.listaJanelaPermissaoOcorrencias.indexOf(indice);

        this.listaJanelaPermissaoOcorrencias.splice(index, 1);

    }
}



// WEBPACK FOOTER //
// ./src/app/cadastro-janela-permissao-ocorrencia/cadastro-janela-permissao-ocorrencia.component.ts